module.exports = __webpack_public_path__ + "media/src/assets/Images/Transparency-6d87b00a6b37dcd5b64ff6800f690561.svg";